export const FilterComponentObj = {

    customerNameKey: "",
    shipNameImokey: "",
    servicetype: "",
    reportstatus: "",

    Fqtsamplestatus: "",
    Fqtreportstatus: "",
    Fqtbunkerport: "",
    Fqtbunkercity: "",
    Fqtlab:"",
    FqtSupplier:"",
    FqtShipType:"",
    Fqtsamplenumber: "",
    Fqtbargename: "",
    Fqtfuelgrade: "",
    FqtOffSpec:"",
    Fqtreportstartdate: null,
    Fqtreportenddate: null,
    Fqtsamplestartdate: null,
    Fqtsampleenddate: null,
    Fqtbunkerstartdate: null,
    Fqtbunkerenddate: null,

    lubesamplestatus: "",
    lubereportstatus: "",
    lubelab: "",
    lubeequipname: '',
    lubeequipmake: "",
    lubeequipmodel: "",
    lobrand: "",
    lograde: "",
    lubeShipType:"",
    lubesamplestartdate:null,
    lubesampleenddate:null,
    lubereportstartdate:null,
    lubereportenddate:null,

    Totsamplestatus: "",
    Totreportstatus: "",
    Totserialnumber: "",
    Totlocation: "",
    Totclientcontract: "",
    Totlab:"",
    Totvoltage: "",
    Totmanufacture:"",
    Totsamplenumber: "",
    TotRating:"",
    TotUnitDescription:"",
    TotSubCustomerName:"",
  
    Totsamplestartdate: null,
    Totsampleenddate: null,
    Totreportstartdate:null,
    Totreportenddate:null,
    TotTransformerName:"",
    AssetscustomerNameKey: "",
    TypeofShip:"",
    HistoricVessel: false,
}

